import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";
import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";
import { Props } from "./types";
import { CalendarIcon } from "./calendarIcon";
import { StatusIcon } from "./statusIcon";
import { WorkloadIcon } from "./workloadIcon";
import { TimeSheetIcon } from "./timeSheetIcon";
import { BudgetIcon } from "./budgetIcon";
import { StrategicAxesIcon } from "./strategicAxesIcon";
import { TagIcon } from "./tagIcon";
import { WeatherIcon } from "./weatherIcon";

function ColumnIcon({ project, criteriaKey, className }: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template: planzoneTemplate } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "project",
  );
  const { template: projectTemplate } = useRetrieveSecondaryCriteriaTemplate(
    project ? project.uuid : "",
    "project",
  );
  const template = [...planzoneTemplate, ...projectTemplate];
  const iconMap = {
    projectManagers: <CalendarIcon className={className} />,
    startDate: <CalendarIcon className={className} />,
    endDate: <CalendarIcon className={className} />,
    tags: <TagIcon className={className} />,
    status: <StatusIcon className={className} />,
    weather: <WeatherIcon className={className} />,
    strategicScore: <StrategicAxesIcon className={className} />,
    activityMonitoring: <TimeSheetIcon className={className} />,
    activityMonitoring_done: <TimeSheetIcon className={className} />,
    activityMonitoring_delayed: <TimeSheetIcon className={className} />,
    activityMonitoring_opened: <TimeSheetIcon className={className} />,
    workload: <WorkloadIcon className={className} />,
    workload_allocatedTime: <WorkloadIcon className={className} />,
    workload_spentTime: <WorkloadIcon className={className} />,
    workload_remainingWork: <WorkloadIcon className={className} />,
    budget: <BudgetIcon className={className} />,
    budget_plannedBudget: <BudgetIcon className={className} />,
    budget_realCosts: <BudgetIcon className={className} />,
    budget_acquiredValue: <BudgetIcon className={className} />,
    text: <SecondaryCriteriaIcon type="text" className={className} />,
    date: <SecondaryCriteriaIcon type="date" className={className} />,
    number: <SecondaryCriteriaIcon type="number" className={className} />,
    list: <SecondaryCriteriaIcon type="list" className={className} />,
    document: <SecondaryCriteriaIcon type="document" className={className} />,
    link: <SecondaryCriteriaIcon type="link" className={className} />,
    resource: <SecondaryCriteriaIcon type="resource" className={className} />,
  };
  const criteria = template.find(({ uuid }) => uuid === criteriaKey);

  return (
    iconMap[(criteria ? criteria.type : criteriaKey) as keyof typeof iconMap] ||
    iconMap.text
  );
}

export { ColumnIcon };
